import gql from 'graphql-tag';

export const SearchLostAndFoundIssue = gql`
  query LostAndFoundIssueTableConnection($input: LostAndFoundIssueWithCacheConnectionInput) {
    searchLostAndFoundIssue {
      lostAndFoundIssueTableConnection(input: $input) {
        totalCount
        edges {
          node {
            createdAt
            createdBy
            crewAirportCode
            crewDriverName
            crewFlightNumber
            crewFlightName
            crewMemberEmail
            crewMemberName
            crewMemberPhone
            datetime
            deletedAt
            deletedBy
            description
            dispatcherEmployeeId
            dispatcherFirstName
            dispatcherId
            dispatcherLastName
            driverEmployeeId
            driverFirstName
            driverId
            driverLastName
            id
            itemLost
            notes
            outboundDatetime
            outboundFlightNumber
            outboundFlightName
            returnStatus
            shippingAddress
            shippingCity
            shippingCost
            shippingMethod
            shippingStateCode
            shippingZipCode
            traceId
            trackingNumber
            tripAirportCode
            tripFlightNumber
            tripLoopName
            tripId
            tripScheduled
            tripServicerIataAirlineCode
            updatedAt
            updatedBy
            vehicleId
            vehicleTrackingId
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
      }
    }
  }
`;
